import cn from 'classnames'
import React, { ComponentProps, useId } from 'react'

type CloudOffCircleIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CloudOffCircleIcon(props: CloudOffCircleIconProps) {
  const { className = '', ...rest } = props
  const clipId = useId()
  return (
    <svg
      className={cn('CloudOffCircleIcon', className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="#B3B7BE"
        stroke="white"
        strokeWidth="2"
      />
      <g clipPath={`url(#${clipId})`} transform="translate(3.75 3.75)">
        <path
          d="M11.3022 8.39484C11.4031 8.13331 11.4583 7.84915 11.4583 7.55208C11.4583 6.33147 10.5253 5.3288 9.33346 5.21842C9.08968 3.73549 7.80195 2.60417 6.25 2.60417C6.01741 2.60417 5.79076 2.62958 5.57267 2.67777M3.79555 3.79471C3.47561 4.2001 3.25395 4.68665 3.16653 5.21842C1.97474 5.3288 1.04166 6.33147 1.04166 7.55208C1.04166 8.8465 2.091 9.89583 3.38541 9.89583H9.11458C9.35212 9.89583 9.58141 9.86049 9.79747 9.79479M1.5625 1.5625L10.9375 10.9375"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="12.5" height="12.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
